import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { _get } from "../auth/Api";
import { customStyleMd } from "../utils/common";
import { _api } from "@iconify/react";

export const FormModal = (props) => {
    const {
        register,
        handleSubmit,
        setValue,
        reset,
        clearErrors,
        control,
        unregister,
        formState: { errors },
    } = useForm();

    const [loading, setLoading] = useState(false);
    const [dropdownOptions, setDropdownOptions] = useState({});

    useEffect(() => {
        if (props.show) {
            // Set field values for edit mode
            if (props.selectedData && Object.keys(props.selectedData).length > 0) {
                //debugger
                if (props.page === "Users") {
                    unregister("password")
                    unregister("userEmail")
                }
                props.config.fields.forEach((field) => {
                    const value = props.selectedData[field.fieldName];
                    setValue(field.fieldName, value ?? ""); // set "" if value is null/undefined
                });
            }

            // Fetch dropdown data
            props.config.fields.forEach(async (selectField) => {
                if (selectField?.type === "select" && selectField?.drpData?.url) {
                    try {
                        await _api("GET", selectField.drpData.url, null, (ret) => {
                            if (ret && ret.data?.length > 0) {
                                const options = ret.data.map((item) => ({
                                    value: item[selectField.drpData.value],
                                    label: item[selectField.drpData.displayName],
                                }));
                                setDropdownOptions((prev) => ({
                                    ...prev,
                                    [selectField.fieldName]: options,
                                }));
                                //selectField.drpData.data = options;
                            }
                        });
                    } catch (err) {
                        console.warn("Dropdown API error:", err.message);
                    }
                }
            });
        }
    }, [props.show]);

    const onSubmit = async (data) => {
        try {
            setLoading(true);
            await props.modalsave(data);
            //clearForm();
        } finally {
            setLoading(false);
        }
    };

    const clearForm = () => {
        reset();
        clearErrors();
        //props.modalshow({}, false);
    };

    return (
        <Modal isOpen={props.show} toggle={() => { props.modalshow({}, false); clearForm() }} size={props.size} centered backdrop="static" keyboard={false}>
            <ModalHeader toggle={() => { props.modalshow({}, false); clearForm() }}>
                <span className="text-lg m-auto fw-500">{props.selectedData && Object.keys(props.selectedData).length > 0 ? `Update ${props.page}` : `Create ${props.page}`}</span>
            </ModalHeader>
            <form onSubmit={handleSubmit(onSubmit)}>
                <ModalBody>
                    <div className="row">
                        {props.config?.fields.map((field, key) => {
                            if (!field.isVisible || field.type === "Seperation") return null;

                            // Check if field is required
                            const isRequired = field?.requiredObj?.required || field?.required || false;

                            // Combine all validation rules
                            const validationProps = {
                                required: isRequired ? `${field.displayName} is required` : false,
                                ...(field.validationRules || {}),
                            };

                            const label = (
                                <label className="small">
                                    {field.displayName} {isRequired && "*"}
                                </label>
                            );

                            // Text / Number / Password
                            if (["text", "number", "password"].includes(field.type)) {
                                //if (field.type === "password" && props.selectedData && Object.keys(props.selectedData).length > 0) return null;
                                if (field.type === "password" && props.selectedData && Object.keys(props.selectedData).length > 0) return null;
                                return (
                                    <div key={key} className={field.clsName}>
                                        <div className="form-group mb-3 input-group-md">
                                            {label}
                                            <input
                                                type={field.type}
                                                className="form-control"
                                                placeholder={field.placeHolder}
                                                autoComplete="off"
                                                {...register(field.fieldName, validationProps)}
                                            />
                                            {errors[field.fieldName] && (
                                                <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors[field.fieldName]?.message}</span>
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            // Email
                            if (field.type === "email") {
                                if (props.selectedData && Object.keys(props.selectedData).length > 0 && props.page === "Users") return null;
                                return (
                                    <div key={key} className={field.clsName}>
                                        <div className="form-group mb-3 input-group-md">
                                            {label}
                                            <input
                                                type={field.type}
                                                className="form-control"
                                                placeholder={field.placeHolder}
                                                autoComplete="off"
                                                {...register(field.fieldName, validationProps)}
                                            />
                                            {errors[field.fieldName] && (
                                                <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors[field.fieldName]?.message}</span>
                                            )}
                                        </div>
                                    </div>
                                );
                            }
                            // Textarea
                            if (field.type === "textarea") {
                                return (
                                    <div key={key} className={field.clsName}>
                                        <div className="form-group mb-3 input-group-md">
                                            {label}
                                            <textarea
                                                className="form-control"
                                                rows={field.rows || 3}
                                                placeholder={field.placeHolder}
                                                autoComplete="off"
                                                {...register(field.fieldName, validationProps)}
                                            />
                                            {errors[field.fieldName] && (
                                                <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors[field.fieldName]?.message}</span>
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            // Select / Dropdown
                            if (field.type === "select") {
                                return (
                                    <div key={key} className={field.clsName}>
                                        <div className="form-group mb-3 input-group-md">
                                            {label}
                                            <Controller
                                                name={field.fieldName}
                                                control={control}
                                                rules={validationProps}
                                                render={({ field: f }) => (
                                                    <Select
                                                        {...f}
                                                        // options={field.drpData?.data || []}
                                                        // value={field.drpData?.data?.find((o) => o.value === f.value) || null}
                                                        options={dropdownOptions[field?.fieldName] || []}
                                                        value={dropdownOptions[field?.fieldName]?.find((o) => o.value === f.value) || null}

                                                        onChange={(s) => f.onChange(s?.value || null)}
                                                        placeholder={field.placeHolder}
                                                        isClearable
                                                        styles={customStyleMd}
                                                        className={errors[field.fieldName] ? "is-invalid" : ""}
                                                    />
                                                )}
                                            />
                                            {errors[field.fieldName] && (
                                                <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors[field.fieldName]?.message}</span>
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            return null;
                        })}
                    </div>
                </ModalBody>

                <ModalFooter>
                    {/* <Button className="btn btn-secondary btn-sm" type="button" onClick={clearForm} disabled={loading}>Cancel</Button> */}
                    <Button className="btn btn-changan btn-sm" type="submit" disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                {" "}Saving...
                            </>
                        ) : (
                            props.selectedData && Object.keys(props.selectedData).length > 0 ? "Update" : "Save"
                        )}
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};
